var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "setting-main-container" }, [
    _c(
      "div",
      { staticClass: "card setting-card" },
      [
        _c(
          "div",
          { staticClass: "page-header d-flex justify-content-between" },
          [
            _c("div", [
              _c("h3", { staticClass: "page-title" }, [
                _vm._v(
                  "\n          " +
                    _vm._s(_vm.$t("profile.documents.documents")) +
                    "\n        "
                ),
              ]),
            ]),
            _vm._v(" "),
            _c(
              "base-button",
              {
                staticClass: "add-new-tax",
                attrs: { outline: "", color: "theme" },
                on: { click: _vm.addDocumentModel },
              },
              [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.$t("profile.documents.add_new")) +
                    "\n      "
                ),
              ]
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "table-component",
          {
            ref: "documentData",
            staticClass: "mb-3",
            attrs: {
              "show-filter": false,
              data: _vm.processDocuments,
              "table-class": "table tax-table",
            },
          },
          [
            _c("table-column", {
              attrs: {
                label: _vm.$t("profile.documents.document_type"),
                show: "documentType.name",
              },
            }),
            _vm._v(" "),
            _c("table-column", {
              attrs: {
                label: _vm.$t("profile.documents.document_name"),
                show: "name",
              },
            }),
            _vm._v(" "),
            _c("table-column", {
              attrs: {
                sortable: false,
                filterable: false,
                "cell-class": "action-dropdown",
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (row) {
                    return [
                      _c("span", [
                        _vm._v(" " + _vm._s(_vm.$t("customers.action")) + " "),
                      ]),
                      _vm._v(" "),
                      _c(
                        "v-dropdown",
                        [
                          _c(
                            "a",
                            {
                              attrs: { slot: "activator", href: "#" },
                              slot: "activator",
                            },
                            [_c("dot-icon")],
                            1
                          ),
                          _vm._v(" "),
                          _c("v-dropdown-item", [
                            _c("div", { staticClass: "dropdown-item" }, [
                              row.path
                                ? _c(
                                    "a",
                                    {
                                      attrs: {
                                        href: row.path,
                                        target: "_blank",
                                      },
                                    },
                                    [
                                      _c("font-awesome-icon", {
                                        staticClass: "dropdown-item-icon",
                                        attrs: { icon: "eye" },
                                      }),
                                      _vm._v(
                                        "\n                  " +
                                          _vm._s(_vm.$t("general.view")) +
                                          "\n                "
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ]),
                          ]),
                        ],
                        1
                      ),
                    ]
                  },
                },
              ]),
            }),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }